import React from 'react'
import {observer} from 'mobx-react-lite'
import {useConnector} from 'react-instantsearch-hooks-web'
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats'

import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats'
import {Text} from '../../../vanilla'
import {getProductListDefaults} from '../../../constants'
import {useGlobalStore, useProductStore} from '../../../store/hooks/useStore'

export type UseStatsProps = StatsConnectorParams

export function useStats(props?: UseStatsProps) {
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats, props)
}

export function Stats(props: UseStatsProps) {
  const {nbHits} = useStats(props)

  const getStatsMessage = () => {
    return `${nbHits} products found`
  }

  return (
    <Text id="stats-text" variant="text3" color="gray800" textDecoration="none" lineHeight="taller" data-test-selector="viewing-results-total">
      {getStatsMessage()}
    </Text>
  )
}

export const EndStats = observer((props: UseStatsProps) => {
  const {page, nbHits} = useStats(props)
  const {accumulatedHits, firstLoadedPage} = useProductStore()
  const {customSitePreferences} = useGlobalStore()

  const getEndStatsMessage = () => {
    if (nbHits === 0) return 'Viewing 0-0 of 0 products'

    const hitsPerPage = getProductListDefaults(customSitePreferences).resultsSize
    const loadedHitCount = accumulatedHits.length
    const startIndex = loadedHitCount > 0
      ? firstLoadedPage * hitsPerPage + 1
      : page * hitsPerPage + 1
    const endIndex = loadedHitCount > 0
      ? Math.min(startIndex + loadedHitCount - 1, nbHits)
      : Math.min((page + 1) * hitsPerPage, nbHits)

    return `Viewing ${startIndex}-${endIndex} of ${nbHits} products`
  }

  return (
    <Text id="end-stats-text" variant="text3" color="gray800" textDecoration="none" lineHeight="taller" data-test-selector="viewing-results-count" textAlign="center">
      {getEndStatsMessage()}
    </Text>
  )
})
